// material-ui
import { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

// ==============================|| OVERRIDES - DIALOG ||============================== //

export default function Dialog(theme: Theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        root: {
          '& .MuiBackdrop-root': {
            backgroundColor: alpha(theme.palette.common.black, 0.7),
          },
        },
      },
    },
  };
}
